import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/components/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => {
        setUser(data);
        navigate("/admin/reservations", { replace: true, state: { user: data } });
      })
      .catch((err) => {
        setUser(false);
        setError(formatApiErrorDetail(err.response?.data?.detail));
      });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-6 py-32" data-testid="auth-callback-page">
      {error ? (
        <div className="w-full rounded-2xl border border-[#2C2A29]/10 bg-white p-8 text-center shadow-sm">
          <p className="text-sm text-argia-red" data-testid="auth-callback-error">{error}</p>
          <button
            data-testid="auth-callback-retry"
            onClick={() => navigate("/admin/login", { replace: true })}
            className="mt-6 inline-flex items-center justify-center rounded-full bg-argia-red px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-argia-redDark"
          >
            Retour à la connexion
          </button>
        </div>
      ) : (
        <Loader2 size={28} className="animate-spin text-argia-red" />
      )}
    </div>
  );
}
